<template>
  <div id="myBill">

    <mt-header title="我的发票" style="height: 50px">
      <router-link to="/mine" slot="left">
        <mt-button>
          <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
        </mt-button>
      </router-link>
    </mt-header>
    <hr style="height: 1px;background-color: #d8d8d8;"/>

    <p id="myBill-content-detail">
      发票业务正在升级中......
    </p>

    <p id="myBill-content-detail2">
      您可通过以下两种方式进行发票申请<br />
      1.&nbsp&nbsp电脑访问www.blissmall.net，点击页面底部“发票申请”进入 <br />
      2.&nbsp&nbsp拨打客服电话400-999-6666进行人工申请<br />
    </p>

  </div>
</template>

<script>

  export default {
    name: 'myBill',
    mounted () {
    },
    destroyed () {
    },
    computed: {
    }
  }
</script>



<style lang="scss">
  @import '../../../assets/css/mixin';

  #myBill-content-detail {
    margin-left: pxToRem(90px);
    text-align: center;
    margin-right: pxToRem(90px);
    margin-top: pxToRem(120px);
    font-size: pxToRem(24px);
  }

  #myBill-content-detail2 {
    font-size: pxToRem(22px);
    color: #666666;
    margin-left: pxToRem(85px);
    margin-right: pxToRem(85px);
    margin-top: pxToRem(54px);
  }
</style>


// WEBPACK FOOTER //
// myBill.vue?4a2d9d02